import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
import { accountEntityName } from './accountTypes';
export const accountExportTemplateEntityName = 'accountExportTemplate';
export const accountExportTemplateSchema = z.object({
    name: z.string(),
    accountId: z.string().uuid(),
    fields: z
        .object({
        headerName: z.string(),
        source: z.string().optional(),
        type: z.string().optional(),
        default: z.boolean(),
    })
        .array(),
});
export const accountExportTemplateColumns = defineColumns({
    accountId: {
        type: 'foreign-key',
        entity: accountEntityName,
        onDeleteCascade: true,
    },
    name: {
        type: 'string-required',
    },
    headerNames: {
        type: 'string-array',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
